"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _spamService = require("@insided/shared/services/spamService");

var _logger = require("@insided/shared/services/logger");

var _globals = require("@insided/shared/utils/globals");

var _utils = require("./utils");

var _SidebarMenuItem = _interopRequireDefault(require("./SidebarMenuItem"));

var _SidebarDetailsMenu = _interopRequireDefault(require("./SidebarDetailsMenu"));

var _NavigationLogo = _interopRequireDefault(require("./NavigationLogo"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var fetchModerationOverviewViews = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var response, data;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _axios.default.get('/views');

          case 3:
            response = _context.sent;
            data = response.data;
            return _context.abrupt("return", data.map(function (view) {
              var label = view.name;
              return {
                label: label,
                route: "/overview/".concat(view.id)
              };
            }));

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);

            if (!(_context.t0.response.status !== 404)) {
              _context.next = 12;
              break;
            }

            throw _context.t0;

          case 12:
            return _context.abrupt("return", []);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function fetchModerationOverviewViews() {
    return _ref.apply(this, arguments);
  };
}();

var ControlSideMenu = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ControlSideMenu, _Component);

  var _super = _createSuper(ControlSideMenu);

  function ControlSideMenu() {
    var _this;

    (0, _classCallCheck2.default)(this, ControlSideMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      activeItemName: null,
      isOpen: true,
      isOverlay: false,
      customViews: [],
      spamCount: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setSpamCount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _yield$getSpamContent, data;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _spamService.getSpamContentCount)();

            case 3:
              _yield$getSpamContent = _context2.sent;
              data = _yield$getSpamContent.data;

              _this.setState({
                spamCount: data.result.count
              });

              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              _logger.logger.error(_context2.t0, {
                component: 'ControlSideMenu',
                action: 'setSpamCount'
              });

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(ControlSideMenu, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var _this2 = this;

        var _this$props, sidebar, customFilters, contentMenu, spamMenuItem, customViews;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$props = this.props, sidebar = _this$props.sidebar, customFilters = _this$props.customFilters;
                contentMenu = sidebar.find(function (item) {
                  return item.label === 'Content';
                });
                spamMenuItem = contentMenu === null || contentMenu === void 0 ? void 0 : contentMenu.links.moderation.find(function (item) {
                  return item.label === 'Spam';
                });
                this.setActiveItem(sidebar, customFilters);

                if (!contentMenu) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 7;
                return fetchModerationOverviewViews();

              case 7:
                customViews = _context4.sent;
                this.setState({
                  customViews: customViews
                });

              case 9:
                if (!spamMenuItem) {
                  _context4.next = 12;
                  break;
                }

                _context4.next = 12;
                return this.setSpamCount();

              case 12:
                window.addEventListener('hashchange', function () {
                  return _this2.forceUpdate();
                });
                (0, _globals.subscribe)('posts_marked_as_spam', this.setSpamCount);
                (0, _globals.subscribe)('posts_marked_as_not_spam', this.setSpamCount);
                (0, _globals.subscribe)('posts_permanently_deleted_spam', this.setSpamCount); // this is fired when approving pending posts and marking posts and not spam from legacy code

                window.addEventListener('updateMenuCounts', function () {
                  ;
                  (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
                    return _regenerator.default.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return _this2.setSpamCount();

                          case 2:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }))();
                });

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "setActiveItem",
    value: function setActiveItem(sidebar, customFilters) {
      var _this3 = this;

      var customViews = this.state.customViews;
      var activeItems = sidebar.filter(function (item) {
        return (0, _utils.isItemActive)(item, customFilters, customViews);
      });
      activeItems.forEach(function (item) {
        _this3.setState({
          activeItemName: item.name,
          isOpen: true
        }, function () {
          _this3.toggleMenuClass(true);
        });
      });
    }
  }, {
    key: "toggleMenuItem",
    value: function () {
      var _toggleMenuItem = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(event, item) {
        var _this4 = this;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                event === null || event === void 0 ? void 0 : event.preventDefault();
                this.setState({
                  activeItemName: item.name,
                  isOpen: true
                }, function () {
                  _this4.toggleMenuClass(true);
                });

                if (!(item.label.toLowerCase() === 'content')) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 5;
                return this.setSpamCount();

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function toggleMenuItem(_x, _x2) {
        return _toggleMenuItem.apply(this, arguments);
      }

      return toggleMenuItem;
    }() // eslint-disable-next-line class-methods-use-this

  }, {
    key: "toggleMenuClass",
    value: function toggleMenuClass(isOpen) {
      var bodyWrapper = window.document.body;

      if (isOpen) {
        bodyWrapper.classList.add('sidebar-open');
      } else {
        bodyWrapper.classList.remove('sidebar-open');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this,
          _activeSidebar$;

      var _this$props2 = this.props,
          rawSidebar = _this$props2.sidebar,
          customFilters = _this$props2.customFilters,
          customerName = _this$props2.customerName;
      var _this$state = this.state,
          activeItemName = _this$state.activeItemName,
          customViews = _this$state.customViews,
          isOpen = _this$state.isOpen,
          isOverlay = _this$state.isOverlay,
          spamCount = _this$state.spamCount;
      var sidebar = rawSidebar.filter(function (item) {
        // we should filter it on the twig level at navigation.twig
        // although we can skip it because of future decommisioning of the legacy code
        if (item.name === 'privateMessages' || item.name === 'openCommunity' || item.name === 'team') {
          return false;
        }

        return true;
      });
      var activeSidebar = sidebar.filter(function (item) {
        return item.name === activeItemName;
      });
      return (0, _preact.h)("div", {
        className: "control-side-menu-wrapper"
      }, (0, _preact.h)("div", {
        className: "control-side-menu"
      }, (0, _preact.h)(_NavigationLogo.default, {
        customerName: customerName
      }), sidebar.map(function (item) {
        var isActive = (0, _utils.isItemActive)(item, customFilters, customViews);
        return (0, _preact.h)(_SidebarMenuItem.default, {
          key: item.name,
          isActive: isActive,
          item: item,
          onClick: /*#__PURE__*/function () {
            var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(event) {
              return _regenerator.default.wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return _this5.toggleMenuItem(event, item);

                    case 2:
                      return _context6.abrupt("return", _context6.sent);

                    case 3:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee6);
            }));

            return function (_x3) {
              return _ref4.apply(this, arguments);
            };
          }(),
          link: item.link
        });
      })), !((_activeSidebar$ = activeSidebar[0]) !== null && _activeSidebar$ !== void 0 && _activeSidebar$.link) && (0, _preact.h)(_SidebarDetailsMenu.default, {
        isOpen: isOpen,
        isOverlay: isOverlay,
        sidebar: activeSidebar,
        customFilters: customFilters,
        customViews: customViews,
        spamCount: spamCount,
        onSidebarClose: function onSidebarClose() {
          _this5.setState({
            isOpen: false,
            isOverlay: false
          }, function () {
            _this5.toggleMenuClass(false);
          });
        },
        onArrowClick: function onArrowClick() {
          return _this5.setState({
            isOpen: !isOpen,
            isOverlay: false
          }, function () {
            _this5.toggleMenuClass(!isOpen);
          });
        },
        setOverlay: function setOverlay(isOverlay, callback) {
          _this5.setState({
            isOverlay: isOverlay
          }, callback);
        }
      }));
    }
  }]);
  return ControlSideMenu;
}(_preact.Component);

var _default = ControlSideMenu;
exports.default = _default;